import type { PnlWeek } from '@orgus/protocol';
import { COST_CATEGORIES, COST_CATEGORY_LABEL } from '@orgus/protocol';
import { StackedBarChart, formatMoney, formatMoneyCompact } from '@orgus/ui';
import { weekLabel } from './model.ts';

/**
 * What did building this cost each week, and on what (visx, data-viz.md: parts of a total
 * over time are stacked bars): one bar per week, a segment per category present in the period,
 * each category on its own data slot. Hover or focus a week to read it; Table has every number.
 */
export function PnlChart({ weeks, className, frameless }: { weeks: PnlWeek[]; className?: string; frameless?: boolean }) {
  const present = COST_CATEGORIES.filter((c) => weeks.some((w) => w.byCategory[c] > 0));
  const total = weeks.reduce((n, w) => n + w.total, 0);
  const merged = weeks.reduce((n, w) => n + w.merged, 0);
  return (
    <StackedBarChart
      className={className}
      frameless={frameless}
      title="Cost per week, by category"
      summary={`${formatMoney(total)} over ${weeks.length} weeks${merged ? `, ${merged} merges at ${formatMoney(total / merged)} each` : ''}`}
      keys={present.map((c) => ({ key: c, label: COST_CATEGORY_LABEL[c] }))}
      order={[...COST_CATEGORIES]}
      data={weeks.map((w) => ({ label: weekLabel(w.week), values: Object.fromEntries(present.map((c) => [c, w.byCategory[c]])) }))}
      format={formatMoney}
      axisFormat={formatMoneyCompact}
      height={240}
    />
  );
}
